import React from "react";
import { connect } from "react-redux";
import { Button } from "devextreme-react";
import NumberField from "../../../../../Shared/fields/NumberField";
import { setBlocking } from "../actions";

class TooltipBody extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      appointment: props.data,
    };
  }

  getMaxOverBookQuota = (quota) => {
    if (quota.Description === "Ocupacional")
      return quota.OverbookedMaximumAmount < this.props.centerConfig.maxOverBookOcupational ? quota.OverbookedMaximumAmount : this.props.centerConfig.maxOverBookOcupational;
    if (quota.Description === "Preocupacional")
      return quota.OverbookedMaximumAmount < this.props.centerConfig.maxOverBookPreocupational ? quota.OverbookedMaximumAmount : this.props.centerConfig.maxOverBookPreocupational;
    if (quota.Description === "Ciel")
      return quota.OverbookedMaximumAmount < this.props.centerConfig.maxOverBookCiel ? quota.OverbookedMaximumAmount : this.props.centerConfig.maxOverBookCiel;
    return quota.OverbookedMaximumAmount;
  }

  getDisabledQuota = (quota) => {

    if (quota.Description === "Ocupacional")
      return !this.props.centerConfig.canOverBookOcupational;
    if (quota.Description === "Preocupacional")
      return !this.props.centerConfig.canOverBookPreocupational;
    if (quota.Description === "Ciel")
      return !this.props.centerConfig.canOverBookCiel;
    return false;
  }

  handleChange = (e, quotaType, amountType) => {
    const newQuota = { ...this.state.appointment };

    const editedQuotas = newQuota.Quotas.map((q) => {
      if (q.Description === quotaType) {        
        const newQ = { ...q };        
        newQ[amountType] = e.value;
        if(amountType === "QuantityQuotaAvailable"){
          let quotaBlocked = newQ.QuantityQuota - newQ.QuantityQuotaAvailable;
          newQ.QuantityQuotasBlocked = quotaBlocked > 0 && quotaBlocked <= newQ.QuantityQuota ? quotaBlocked : 0;
          newQ.QuantityQuotaBlocked = newQ.QuantityQuotasBlocked
        } else if(amountType === "QuantityOverQuotaAvailable"){
          let overQuotaBlocked = newQ.QuantityOverQuota - newQ.QuantityOverQuotaAvailable;
          newQ.QuantityOverQuotasBlocked = overQuotaBlocked > 0 && overQuotaBlocked <= newQ.QuantityOverQuota ? overQuotaBlocked : 0;
          newQ.QuantityOverQuotaBlocked = newQ.QuantityOverQuotasBlocked;
        }
        return newQ;
      }
      return q;
    });

    newQuota.Quotas = editedQuotas;

    this.setState({ appointment: newQuota });
  }

  mappingQuotas = (item, appointment) => {
    if(item.Quotas && item.Quotas.length && appointment.Quotas && appointment.Quotas.length){
      let newQuotas = item.Quotas.map(q => {
        let _quota = appointment.Quotas.find(a => a.QuotaId === q.QuotaId)
        if(!_quota) return q;
        _quota.OpeningQuotaId = q.OpeningQuotaId;
        return {..._quota};
      })
      item.Quotas = [...newQuotas];
      return item;
    }
    return item
  }

  handleRow = () => {
    const newBlocking = { ...this.props.blocking };
    const _appointment = this.state.appointment;
    const newData = newBlocking.data.map((item) => {
      if (item.endDateInt === _appointment.endDateInt
        && item.startDateInt === _appointment.startDateInt) {
          let _res = this.mappingQuotas(item, _appointment); 
          return _res;
      }
      return item;
    });
    if (newBlocking.IdConfig > 0) {
      newBlocking.isNewConfig = true;
    }
    newBlocking.data = newData;
    newBlocking.completeData[newBlocking.dataPage] = newData;
    this.props.dispatch(setBlocking(newBlocking));
  }

  handleColumn = () => {
    const newBlocking = { ...this.props.blocking };
    const _appointment = this.state.appointment;
    const newData = newBlocking.data.map((item) => {
      if (item.day === _appointment.day) {
        let _res = this.mappingQuotas(item, _appointment); 
          return _res;
      }
      return item;
    });
    if (newBlocking.IdConfig > 0) {
      newBlocking.isNewConfig = true;
    }
    newBlocking.data = newData;
    newBlocking.completeData[newBlocking.dataPage] = newData;
    this.props.dispatch(setBlocking(newBlocking));
  }
  handleWeek = () => {
    const newBlocking = { ...this.props.blocking };
    const _appointment = this.state.appointment;
    const newData = newBlocking.data.map((item) => {
      return this.mappingQuotas(item, _appointment);
    });
    if (newBlocking.IdConfig > 0) {
      newBlocking.isNewConfig = true;
    }
    newBlocking.data = newData;
    newBlocking.completeData[newBlocking.dataPage] = newData;
    this.props.dispatch(setBlocking(newBlocking));
  }

  handleSelected = () => {
    const newBlocking = { ...this.props.blocking };
    const _appointment = this.state.appointment;
    const newData = newBlocking.data.map((item) => {
      if (item.endDateInt === _appointment.endDateInt &&
        item.startDateInt === _appointment.startDateInt &&
        item.day === _appointment.day) {
        return { ...item, Quotas: _appointment.Quotas };
      }
      return item;
    });
    if (newBlocking.IdConfig > 0) {
      newBlocking.isNewConfig = true;
    }
    newBlocking.data = newData;
    newBlocking.completeData[newBlocking.dataPage] = newData;
    this.props.dispatch(setBlocking(newBlocking));
  }

  render() {
    const { appointment } = this.state;
    return (
      <div className="scheduler-tooltip" style={{ minHeight: 360, minWidth: 400 }}>
        <div className="cupos-wrapper">
          {appointment.Quotas && appointment.Quotas.length && appointment.Quotas.map((item, index) => {
            if(item.Status !== 1) return "";
            return <div className="row" key={item.Description +"-"+ index}>
              <div className="col-6">
                <NumberField
                  id={`cupos${item.Description}`}
                  label={item.Description}
                  min={0}
                  value={appointment[`cupos${item.Description}`] || item.QuantityQuotaAvailable}
                  onChange={(data) => this.handleChange(data, item.Description, "QuantityQuotaAvailable", index)}
                  showSpinButtons
                />
              </div>
              <div className="col-6">
                <NumberField
                  id={`sobreCupo${item.Description}`}
                  disabled={this.getDisabledQuota(item)}
                  min={0}
                  max={this.getMaxOverBookQuota(item)}
                  label={`Sobrecupo ${item.Description}`}
                  value={appointment[`sobreCupo${item.Description}`] || item.QuantityOverQuotaAvailable}
                  onChange={(data) => this.handleChange(data, item.Description, "QuantityOverQuotaAvailable", index)}
                  showSpinButtons
                />
              </div>
            </div>
          })}
        </div>

        <div className="row" style={{ marginTop: 20 }}>
          <div className="col-12">
            <h3><p>Repetir en: </p></h3>
          </div>
          <div className="col-3">
            <Button
              onClick={this.handleRow}
              text="Módulo"
              type="success"
              width="100%"
              stylingMode="outlined"
            />
          </div>
          <div className="col-3">
            <Button
              onClick={this.handleColumn}
              text="Dia"
              width="100%"
              type="success"
              stylingMode="outlined"
            />
          </div>
          <div className="col-3">
            <Button
              onClick={this.handleWeek}
              type="success"
              width="100%"
              text="Semana"
              stylingMode="outlined"
            />
          </div>
          <div className="col-3">
            <Button
              onClick={this.handleSelected}
              type="success"
              width="100%"
              text="Aplicar"
              stylingMode="outlined"
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  blocking: state.bloqueosSel.blocking,
  centerConfig: state.bloqueosSel.centerConfig,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(TooltipBody);
